import {LOCAL_STORAGE_KEYS} from "../utils/constants";
import {invokeApi} from "../bl_libs/invokeApi";

export const getIndividualRubricScoreService = async (org_code, module_code, userid) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/individual/rubric/score',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        org_code,
        module_code,
        userid
    };
    return invokeApi(requestObj);
}

export const getNationalGlobalRubricScoreService = async (selected_country, assess_list) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    let requestObj = {
        path   : '/analytics/individual/national_global/rubric/score',
        method : 'POST', headers : { 'Authorization' : `Bearer ${token}` }
    };
    requestObj['postData'] = {
        selected_country,
        assess_list
    };
    return invokeApi(requestObj);
}